import "./Page.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import Match from "../components/Match";

import { Container, Row, Col } from "reactstrap";

import GoogleMap from "../components/GoogleMaps/GoogleMap";

import { Form } from "./Form.js";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

class Page extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { googleMapsApiKey, pathname } = this.props;

    const seoTitle = "Kontakt";
    const seoDescription =
      "Jesteś zainteresowany współpracą? Masz pytania? Zapraszamy do kontaktu!";

    return (
      <div className="contact-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/home-background.jpg"
            }
          ]}
        />
        <Header />

        <div className="hero-section">
          <GoogleMap
            lat={52.746531}
            lng={15.2191123}
            zoom={7}
            width="100%"
            height="100%"
            apiKey={googleMapsApiKey}
          />
        </div>

        <div className="contact-section">
          <div className="width-wrapper wrapper-padding">
            <Row className="flex-items-xs-center">
              <Col className="text-xs-center" xs="12" sm="10">
                <div className="title">Kontakt</div>
                <div className="description">
                  Jesteś zainteresowany współpracą? Masz pytania? Zapraszamy do
                  kontaktu!
                </div>
              </Col>

              <Col xs="12">
                <Row className="flex-items-xs-center">
                  <Col className="contact-item" xs="12" sm="6" lg="4">
                    <Row className="flex-items-xs-center flex-items-xs-middle">
                      <Col xs="4" sm="3">
                        <div className="icon-wrapper active">
                          <i className="fa fa-map-marker" />
                        </div>
                      </Col>
                      <Col xs="7" sm="6">
                        <div className="item-title">Adres</div>
                        <div className="item-description">ul. Żwirowa 54</div>
                        <div className="item-description">
                          66-400 Gorzów Wlkp.
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="contact-item" xs="12" sm="6" lg="4">
                    <Row className="flex-items-xs-center flex-items-xs-middle">
                      <Col xs="4" sm="3">
                        <div className="icon-wrapper">
                          <i className="fa fa-envelope-o" />
                        </div>
                      </Col>
                      <Col xs="7" sm="6">
                        <div className="item-title">Email</div>
                        <div className="item-description">
                          info@opiekujsie.pl
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>

        <Form />

        <Footer />
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    googleMapsApiKey: state.config.googleMapsApiKey
  }),
  {}
)(Page);



/** WEBPACK FOOTER **
 ** ./src/browser/contact/Page.js
 **/